// Categories configuration
export const categories = [
  {
    id: 'tools',
    name: '币圈入门',
    description: '新手必读的入门指南',
    path: '/category/tools',
    icon: '📖'
  },
  {
    id: 'coin-insights',
    name: '币圈感悟',
    description: '投资心得与市场观察',
    path: '/category/coin-insights',
    icon: '💭'
  },
  {
    id: 'scam-prevention',
    name: '币圈防骗常识',
    description: '识别骗局，保护资产',
    path: '/category/scam-prevention',
    icon: '🛡️'
  },
  {
    id: 'coin-rules',
    name: '币圈铁律',
    description: '投资必须遵守的原则',
    path: '/category/coin-rules',
    icon: '⚖️'
  },
  {
    id: 'airdrop-tips',
    name: '撸毛心得',
    description: '空投获取技巧与经验',
    path: '/category/airdrop-tips',
    icon: '🎁'
  },
  {
    id: 'trading-tips',
    name: '打狗心得',
    description: '交易策略与技巧分享',
    path: '/category/trading-tips',
    icon: '📈'
  },
  {
    id: 'pdf-collection',
    name: '必读电子书',
    description: '精选电子书资源',
    path: '/category/pdf-collection',
    icon: '📚'
  },
  {
    id: 'kol-list',
    name: '必关博主/kol/聪明钱地址',
    description: '值得关注的KOL和地址',
    path: '/category/kol-list',
    icon: '⭐'
  }
];
